import React from "react";
import { useNavigate } from "react-router-dom";
import EN from "../../locales/en";
import TextField from "./partials/TextField";

const YourAddress = ({ values }) => {
  const navigate = useNavigate();
  const changeAddress = () => {
    navigate("/address");
  };
  return (
    <div>
      <h2 className="text-[30px] font-bold text-primary mt-6 pt-6">
        {EN.switch.your_address.title}
      </h2>
      <p className="text-md leading-[1.5] mt-2">
        {values?.customerInfo?.custLabel ?? ""}
      </p>
      <div className="mt-2 flex">
        <button
          onClick={changeAddress}
          className="text-primary underline inline-block"
        >
          {EN.switch.your_address.change_your_address}
        </button>
      </div>

      <h3 className="text-[22px] font-bold mt-8">
        {EN.switch.your_address.move_in_date_title}
      </h3>

      <p className="text-md leading-[1.5] mt-2">
        {EN.switch.your_address.move_in_date_subtitle}
      </p>
      <TextField
        key="customerInfo.moveInDate"
        name="customerInfo.moveInDate"
        type="date"
      />
    </div>
  );
};

export default YourAddress;
